import { PaymentScheduleType } from '../state/configuration'
import {
  AdditionalPriceOption,
  InsuredAsset,
  InsuredProfile,
  PriceOption,
  Quote,
} from './types'

export const getInsuredProfile = (quote: Quote, profileCode: string | undefined) =>
  quote.insuredProfiles.find((it) => it.profileCode === profileCode)

export const getAdditionalProfiles = (quote: Quote) =>
  quote.insuredProfiles.filter((it) => !it.policyholder)

export const getPolicyholder = (quote: Quote): InsuredProfile => {
  const policyholder = quote.insuredProfiles.find((it) => it.policyholder)

  if (!policyholder) {
    throw new Error('Quote does not have a policyholder')
  }

  return policyholder
}

export const getCoreAsset = (quote: Quote): InsuredAsset => {
  const asset = quote.insuredAssets.find((it) => it.coreAsset)

  if (!asset) {
    throw new Error('Quote does not have a core asset')
  }

  return asset
}

export const getPriceBreakdown = (
  quote: Quote,
  paymentType?: PaymentScheduleType,
): PriceOption[] | undefined =>
  quote.availableCoverLevelOptions.find((it) =>
    paymentType ? it.paymentScheduleType === paymentType : it.active,
  )?.premiumBreakdown

export const getAdditionalPriceBreakdown = (
  quote: Quote,
  paymentType?: PaymentScheduleType,
): AdditionalPriceOption[] | undefined =>
  quote.availableCoverLevelOptions.find((it) =>
    paymentType ? it.paymentScheduleType === paymentType : it.active,
  )?.additionalPremiumBreakdown

export const getPaymentScheduleType = (quote: Quote) =>
  quote.availableCoverLevelOptions.find((it) => it.active)?.paymentScheduleType
